const sortCodeValues = (
  a: { sortKey: string; value: string },
  b: { value: string; sortKey: string }
) => {
  // sortKeys start at 1 for Kodeverk i standarder, if 0 or undefined, sort by value
  if (a.sortKey === "0" || a.sortKey === undefined) {
    return !Number.isNaN(Number.parseInt(a.value)) &&
      !Number.isNaN(Number.parseInt(b.value))
      ? Number.parseInt(a.value) - Number.parseInt(b.value)
      : a.value.localeCompare(b.value);
  }
  return Number.parseInt(a.sortKey) - Number.parseInt(b.sortKey);
};

export default sortCodeValues;
